import productBannerImg from "../../../assets/img/product-gg-banner.png";
import productBannerImgWebp from "../../../assets/img/product-gg-banner.webp";
import { ggProductName } from "../../../data/product";

const TestimonialBanner = () => (
    <section id="banner" className="gg-bg-gradient-h ">
        <div className="container-fluid text-white text-center pb-3">
            <div className="row align-items-center justify-content-center pb-5">
                <div className="col-11 text-center">
                    <h1 className="fw-bold" dangerouslySetInnerHTML={{ __html: ggProductName }}></h1>
                </div>
            </div>
            <div className="row align-items-center justify-content-center pb-3">
                <div className="col-lg-2 col-md-3 col-4 ">
                    <picture>
                        <source srcSet={productBannerImgWebp} type="image/webp" />
                        <img className="img-fluid gg-img-display-product" width='150' height='250' src={productBannerImg} loading="lazy" />
                    </picture>
                </div>
            </div
            ><div className="row align-items-center justify-content-center">
                <div className="col-xl-5 col-md-7 col-10 text-center">
                    <h3 className="fw-bold">Still Wondering If GlucoGen<sup>17</sup> Really Works?</h3>
                    <p className="mt-3">See Why Thousands Made the Switch.</p>
                </div>
            </div>
        </div>
    </section >
);

export default TestimonialBanner;